export default __webpack_public_path__ + "static/media/node-logo.5ab66208.png";